import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type OrganizationUpdateFailedAction = {
	type: 'ORGANIZATION_UPDATE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): OrganizationUpdateFailedAction => ({
	type: 'ORGANIZATION_UPDATE_FAILED',
	payload,
});
